import classNames from 'classnames';
import { FormattedDate } from 'react-intl';
import styled from 'styled-components';

import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { LabelM } from '@sorare/core/src/atoms/typography';

const Root = styled(Horizontal)`
  padding: var(--half-unit) var(--unit);
  border-radius: var(--double-unit);
  background-color: var(--c-neutral-300);

  &.noBackground {
    background-color: unset;
  }
`;

type Props = { startDate: Date; endDate: Date; noBackground?: boolean };
export const SeasonInterval = ({ startDate, endDate, noBackground }: Props) => {
  return (
    <Root className={classNames({ noBackground })}>
      <LabelM as="span">
        <FormattedDate value={startDate} month="short" day="numeric" />
        -
        <FormattedDate value={endDate} day="numeric" />
      </LabelM>
    </Root>
  );
};
